<script setup>
import { useBreakpoints, breakpointsBootstrapV5 } from '@vueuse/core';

/**
 * Bootstrap break points to change nav class
 */
const breakpoints = useBreakpoints(breakpointsBootstrapV5);

const smallerThanLg = breakpoints.smaller('lg'); // only smaller than lg
</script>

<template>
  <nav
    class="nav flex-lg-column flex-row flex-nowrap overflow-x-auto"
    :class="smallerThanLg ? 'nav-underline' : 'nav-pills'"
  >
    <RouterLink
      :to="{ name: 'profile.detail' }"
      class="text-nowrap text-center text-lg-start nav-link"
    >
      Profile
    </RouterLink>
    <RouterLink
      :to="{ name: 'profile.event.result.list' }"
      class="text-nowrap text-center text-lg-start nav-link"
    >
      Comp Results
    </RouterLink>
  </nav>
</template>
